import { render, staticRenderFns } from "./BbeeCalidadPCC.vue?vue&type=template&id=37cb6ea4"
import script from "./BbeeCalidadPCC.vue?vue&type=script&lang=js"
export * from "./BbeeCalidadPCC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports